(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementLocalization extends HTMLElement {
    connectedCallback() {
      this.headerGroup = this.closest('#header-group');
      if (!this.headerGroup) return;
      this.origins = new Map();
      this.controller = new AbortController();
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.headerGroup, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);
      this.addEventListener('keydown', (event) => this.onKeydown(event), { signal: this.controller.signal });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close();
      }, { signal: this.controller.signal });
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller?.abort();
      this.origins?.forEach(({ parent, next }, selector) => {
        if (parent.isConnected && this.contains(selector)) {
          parent.insertBefore(selector, next?.parentNode === parent ? next : null);
        }
      });
      this.origins?.clear();
    }

    sync() {
      this.headerGroup.querySelectorAll('#header-component .ht-tms-selector').forEach((selector) => {
        if (selector.parentElement?.closest('.ht-tms-selector')) return;
        if (!this.origins.has(selector)) this.origins.set(selector, { parent: selector.parentElement, next: selector.nextSibling });
        this.append(selector);
      });
      this.querySelectorAll('.ht-tms-single-dropdown__container').forEach((selector, index) => {
        const trigger = selector.querySelector('.ht-tms-dropdown__selected');
        const panel = selector.querySelector('.ht-tms-single-dropdown__dropdown-wrapper');
        if (!trigger || !panel) return;
        panel.id ||= `${this.id}-options-${index}`;
        trigger.setAttribute('aria-controls', panel.id);
        trigger.setAttribute('aria-expanded', String(selector.classList.contains('ht-tms-single-dropdown__container--open')));
        trigger.setAttribute('aria-label', trigger.textContent.trim());
        selector.querySelectorAll('.ht-tms-option__item').forEach((option) => {
          option.setAttribute('role', 'button');
          option.tabIndex = -1;
        });
      });
      this.measure();
    }

    measure() {
      if (!this.children.length) return;
      this.closest('.announcement-bar')?.style.setProperty('--td-localization-space', `${Math.ceil(this.getBoundingClientRect().width) + 12}px`);
    }

    close() {
      this.querySelectorAll('.ht-tms-single-dropdown__container--open').forEach((selector) => {
        selector.classList.remove('ht-tms-single-dropdown__container--open');
      });
    }

    onKeydown(event) {
      const selector = event.target.closest('.ht-tms-single-dropdown__container');
      if (!selector) return;
      const trigger = selector.querySelector('.ht-tms-dropdown__selected');
      const options = [...selector.querySelectorAll('.ht-tms-option__item')];
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        trigger?.focus();
      } else if (event.key === 'Enter' || event.key === ' ') {
        const target = event.target.closest('[role="button"]');
        if (!target) return;
        event.preventDefault();
        target.click();
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (!selector.classList.contains('ht-tms-single-dropdown__container--open')) trigger?.click();
        const index = options.indexOf(document.activeElement);
        const next = event.key === 'ArrowDown' ? (index + 1) % options.length : (index <= 0 ? options.length - 1 : index - 1);
        options[next]?.focus();
      }
    }
  }

  if (!customElements.get('td-announcement-localization')) {
    customElements.define('td-announcement-localization', AnnouncementLocalization);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-article-editorial"]) return;
  try {
    
  class TdArticleLayout extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.content = this.querySelector('[data-td-article-content]');
      this.article = this.closest('.td-article');
      this.headings = this.content ? [...this.content.querySelectorAll('h2, h3')] : [];
      this.links = [];

      this.headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = heading.textContent
            .trim()
            .toLowerCase()
            .normalize('NFKD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
          heading.id = `section-${base || index + 1}`;
        }
        heading.dataset.tdTocHeading = '';
      });

      this.querySelectorAll('[data-td-toc-list]').forEach((list) => {
        const fragment = document.createDocumentFragment();
        this.headings.forEach((heading) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(heading.id)}`;
          link.textContent = heading.textContent.trim();
          if (heading.tagName === 'H3') item.classList.add('is-subheading');
          item.append(link);
          fragment.append(item);
          this.links.push(link);
        });
        list.replaceChildren(fragment);
      });

      if (!this.headings.length) {
        this.querySelectorAll('[data-td-toc-desktop], [data-td-toc-mobile]').forEach((toc) => {
          toc.hidden = true;
        });
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
          if (!visible) return;
          this.links.forEach((link) => {
            const isActive = decodeURIComponent(link.hash.slice(1)) === visible.target.id;
            link.classList.toggle('is-active', isActive);
            if (isActive) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        },
        { rootMargin: '-18% 0px -70% 0px' }
      );
      this.headings.forEach((heading) => this.observer.observe(heading));

      this.progress = this.article?.querySelector('[data-td-reading-progress]');
      this.updateProgress = () => {
        if (!this.content || !this.progress) return;
        const rect = this.content.getBoundingClientRect();
        const start = window.scrollY + rect.top - window.innerHeight * 0.2;
        const end = start + rect.height - window.innerHeight * 0.55;
        const ratio = Math.min(1, Math.max(0, (window.scrollY - start) / Math.max(1, end - start)));
        this.progress.style.transform = `scaleX(${ratio})`;
      };
      window.addEventListener('scroll', this.updateProgress, { passive: true, signal });
      window.addEventListener('resize', this.updateProgress, { passive: true, signal });
      this.updateProgress();

      const copyButton = this.article?.querySelector('[data-td-copy-link]');
      copyButton?.addEventListener(
        'click',
        async () => {
          try {
            await navigator.clipboard.writeText(window.location.href);
            const label = copyButton.querySelector('[data-td-copy-label]');
            if (label) label.textContent = copyButton.dataset.copiedLabel;
            window.setTimeout(() => {
              if (label) label.textContent = copyButton.dataset.copyLabel;
            }, 1800);
          } catch {
            window.prompt('', window.location.href);
          }
        },
        { signal }
      );

      const shareButton = this.article?.querySelector('[data-td-native-share]');
      if (shareButton && navigator.share) {
        shareButton.hidden = false;
        shareButton.addEventListener(
          'click',
          () => navigator.share({ title: document.title, url: window.location.href }),
          { signal }
        );
      }

      if (window.location.hash) {
        requestAnimationFrame(() => {
          document.getElementById(decodeURIComponent(window.location.hash.slice(1)))?.scrollIntoView();
        });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('td-article-layout')) {
    customElements.define('td-article-layout', TdArticleLayout);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-brand-finale"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const imageJobs = new WeakMap();
    const readyImages = new WeakSet();
    const prepareImage = (image) => {
      if (!image) return Promise.resolve(true);
      if (imageJobs.has(image)) return imageJobs.get(image);
      const job = new Promise((resolve) => {
        let settled = false;
        const finish = (ok) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          image.removeEventListener('load', loaded);
          image.removeEventListener('error', failed);
          if (ok) readyImages.add(image);
          resolve(ok);
        };
        const loaded = () => {
          if (!image.naturalWidth) return finish(false);
          if (image.decode) image.decode().then(() => finish(true), () => finish(false));
          else finish(true);
        };
        const failed = () => finish(false);
        const timer = setTimeout(() => finish(false), 10000);
        image.addEventListener('load', loaded, { once: true });
        image.addEventListener('error', failed, { once: true });
        image.loading = 'eager';
        if (image.complete && image.naturalWidth) loaded();
      });
      imageJobs.set(image, job);
      job.then(() => imageJobs.delete(image));
      return job;
    };

    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

    const initialize = (root) => {
      if (!root || root.dataset.oneDepotReady === 'true') return;
      root.dataset.oneDepotReady = 'true';
      const scenes = [...root.querySelectorAll('[data-one-depot-scene]')];
      const progressItems = [...root.querySelectorAll('[data-one-depot-progress]')];
      if (!scenes.length) return;
      let frame = 0;
      let currentSceneIndex = 0;
      let sceneAnimation = null;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      let desiredSceneIndex = 0;
      let loadingSceneIndex = -1;
      const warmImages = async () => {
        for (const scene of scenes) {
          if (!root.isConnected) return;
          const image = scene.querySelector('img');
          if (image) image.fetchPriority = 'low';
          await prepareImage(image);
        }
      };
      const warmObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        warmObserver.disconnect();
        warmImages();
      }, { rootMargin: '800px 0px' });
      warmObserver.observe(root);

      const showScene = (index) => {
        if (index === currentSceneIndex) return;
        const outgoingIndex = currentSceneIndex;
        sceneAnimation?.cancel();
        currentSceneIndex = index;
        scenes.forEach((scene, sceneIndex) => {
          scene.classList.toggle('is-active', sceneIndex === index);
          scene.classList.toggle('is-outgoing', sceneIndex === outgoingIndex);
        });
        const finish = () => scenes.forEach((scene) => scene.classList.remove('is-outgoing'));
        const duration = parseFloat(window.getComputedStyle(root).getPropertyValue('--td-one-depot-fade')) || 300;
        if (reducedMotion.matches || !scenes[index].animate) {
          finish();
          sceneAnimation = null;
          return;
        }
        const animation = scenes[index].animate(
          [{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }],
          { duration, easing: 'cubic-bezier(.22, 1, .36, 1)' }
        );
        sceneAnimation = animation;
        animation.onfinish = () => {
          if (sceneAnimation !== animation) return;
          finish();
          sceneAnimation = null;
        };
      };

      const getScrollContainer = () => {
        let element = root.parentElement;
        while (element && element !== document.body) {
          const overflowY = window.getComputedStyle(element).overflowY;
          if (/(auto|scroll)/.test(overflowY) && element.scrollHeight > element.clientHeight) return element;
          element = element.parentElement;
        }
        return document.scrollingElement || document.documentElement;
      };

      const jumpToScene = (index) => {
        const scroller = getScrollContainer();
        const rootRect = root.getBoundingClientRect();
        const scrollerRect = scroller === document.scrollingElement || scroller === document.documentElement
          ? { top: 0 }
          : scroller.getBoundingClientRect();
        const viewportHeight = scroller === document.scrollingElement || scroller === document.documentElement ? window.innerHeight : scroller.clientHeight;
        const travel = Math.max(1, root.offsetHeight - viewportHeight);
        const chapterTop = scroller.scrollTop + rootRect.top - scrollerRect.top;
        const targetProgress = index === 0 ? 0 : (index + .04) / scenes.length;
        scroller.scrollTo({ top: chapterTop + targetProgress * travel, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };

      const render = () => {
        frame = 0;
        const scroller = getScrollContainer();
        const rect = root.getBoundingClientRect();
        const isDocumentScroller = scroller === document.scrollingElement || scroller === document.documentElement;
        const scrollerTop = isDocumentScroller ? 0 : scroller.getBoundingClientRect().top;
        const viewportHeight = isDocumentScroller ? window.innerHeight : scroller.clientHeight;
        const travel = Math.max(1, rect.height - viewportHeight);
        const progress = clamp(-(rect.top - scrollerTop) / travel);
        const scaledProgress = progress * scenes.length;
        const activeIndex = Math.min(scenes.length - 1, Math.floor(scaledProgress));
        const activeProgress = progress >= 1 ? 1 : clamp(scaledProgress - activeIndex);

        desiredSceneIndex = activeIndex;
        const targetImage = scenes[activeIndex].querySelector('img');
        if (activeIndex !== currentSceneIndex && targetImage && !(readyImages.has(targetImage) && targetImage.complete && targetImage.naturalWidth)) {
          if (loadingSceneIndex !== activeIndex) {
            loadingSceneIndex = activeIndex;
            prepareImage(targetImage).then((ready) => {
              if (loadingSceneIndex === activeIndex) loadingSceneIndex = -1;
              if (ready && root.isConnected && desiredSceneIndex === activeIndex) requestRender();
            });
          }
        } else {
          showScene(activeIndex);
        }
        const displayedIndex = currentSceneIndex;
        scenes.forEach((scene, index) => {
          const active = index === displayedIndex;
          scene.style.setProperty('--td-scene-scale', active ? '1' : '1.008');
          scene.classList.toggle('is-active', active);
          scene.setAttribute('aria-hidden', active ? 'false' : 'true');
          const video = scene.querySelector('video');
          if (video) active ? video.play().catch(() => {}) : video.pause();
        });

        progressItems.forEach((item, index) => {
          const itemProgress = index < displayedIndex ? 1 : index === displayedIndex ? (displayedIndex === activeIndex ? activeProgress : 0) : 0;
          item.style.setProperty('--td-item-progress', itemProgress.toFixed(4));
          item.classList.toggle('is-active', index === displayedIndex);
          item.classList.toggle('is-complete', index < displayedIndex);
          item.setAttribute('aria-current', index === displayedIndex ? 'step' : 'false');
        });
      };

      const requestRender = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender, { passive: true });
      document.addEventListener('scroll', requestRender, { passive: true, capture: true });
      progressItems.forEach((item, index) => item.addEventListener('click', () => jumpToScene(index)));
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(root)) return;
        warmObserver.disconnect();
        cancelAnimationFrame(frame);
        sceneAnimation?.cancel();
        window.removeEventListener('scroll', requestRender);
        window.removeEventListener('resize', requestRender);
        document.removeEventListener('scroll', requestRender, true);
        root.removeEventListener('load', requestRender, true);
      });
      root.addEventListener('load', requestRender, true);
      render();
    };

    const initializeAll = (scope = document) => {
      if (scope.matches?.('[data-one-depot]')) initialize(scope);
      scope.querySelectorAll?.('[data-one-depot]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-community-newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 749px)');
    const customScrollRoot = window.matchMedia('(min-width: 769px)');
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const controllers = new WeakMap();

    const init = (root) => {
      if (!root) return;
      controllers.get(root)?.abort();

      const controller = new AbortController();
      const { signal } = controller;
      controllers.set(root, controller);
      root.dataset.tdCommunityReady = 'true';

      const stage = root.querySelector('[data-td-community-stage]');
      const media = root.querySelector('[data-td-community-media]');
      const content = root.querySelector('.td-community__content');
      const email = root.querySelector('.td-community__input');
      const pageWrapper = document.querySelector('.page-wrapper');
      if (!stage || !content) return;

      let frame = 0;
      let formFocused = false;

      const getViewport = () => {
        const useWrapper = customScrollRoot.matches && pageWrapper;
        const viewportHeight = useWrapper
          ? pageWrapper.clientHeight
          : (window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight);

        return {
          width: useWrapper
            ? pageWrapper.clientWidth
            : (window.visualViewport?.width || window.innerWidth || document.documentElement.clientWidth),
          height: viewportHeight,
          top: useWrapper ? pageWrapper.getBoundingClientRect().top : (window.visualViewport?.offsetTop || 0),
        };
      };

      const render = () => {
        frame = 0;

        const viewport = getViewport();
        const rect = root.getBoundingClientRect();
        const scrollDistance = Math.max(1, root.offsetHeight - viewport.height);
        const progress = reduceMotion.matches ? 1 : clamp((viewport.top - rect.top) / scrollDistance);
        const startTopRatio = mobile.matches ? .68 : .70;
        const endTopRatio = mobile.matches
          ? .65
          : viewport.width >= 1400
            ? .67
            : viewport.width >= 1024
              ? .66
              : .65;
        const settlePoint = .33;
        const motionProgress = clamp(progress / settlePoint);
        const stageRect = stage.getBoundingClientRect();
        const contentHeight = content.getBoundingClientRect().height;
        const stageCenter = stageRect.top + (stageRect.height / 2);
        const topRatio = startTopRatio + ((endTopRatio - startTopRatio) * motionProgress);
        const targetTop = reduceMotion.matches
          ? stageRect.top + (stageRect.height * endTopRatio)
          : viewport.top + (viewport.height * topRatio);
        let contentY = targetTop + (contentHeight / 2) - stageCenter;

        media?.style.removeProperty('clip-path');

        if (formFocused && mobile.matches) {
          const visibleBottom = viewport.top + viewport.height;
          const targetCenter = visibleBottom - 24 - (contentHeight / 2);
          contentY = Math.min(contentY, targetCenter - stageCenter);
        }

        root.style.setProperty('--td-content-opacity', reduceMotion.matches ? '1' : (.75 + (.25 * motionProgress)).toFixed(3));
        root.style.setProperty('--td-content-y', `${contentY.toFixed(2)}px`);
        root.dataset.scrollProgress = progress.toFixed(3);
        root.dataset.motionProgress = motionProgress.toFixed(3);
      };

      const requestRender = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(render);
      };

      const passive = { passive: true, signal };
      window.addEventListener('scroll', requestRender, passive);
      window.addEventListener('resize', requestRender, passive);
      document.addEventListener('scroll', requestRender, { passive: true, capture: true, signal });
      pageWrapper?.addEventListener('scroll', requestRender, passive);
      window.visualViewport?.addEventListener('resize', requestRender, passive);
      window.visualViewport?.addEventListener('scroll', requestRender, passive);
      mobile.addEventListener?.('change', requestRender, { signal });
      customScrollRoot.addEventListener?.('change', requestRender, { signal });
      reduceMotion.addEventListener?.('change', requestRender, { signal });

      root.addEventListener('focusin', (event) => {
        if (event.target !== email) return;
        formFocused = true;
        root.style.setProperty('--td-focus-track-height', `${root.offsetHeight}px`);
        root.style.setProperty('--td-focus-stage-height', `${stage.offsetHeight}px`);
        root.dataset.formFocused = 'true';
        requestRender();
      }, { signal });

      root.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (root.contains(document.activeElement)) return;
          formFocused = false;
          delete root.dataset.formFocused;
          root.style.removeProperty('--td-focus-track-height');
          root.style.removeProperty('--td-focus-stage-height');
          requestRender();
        }, 0);
      }, { signal });

      render();
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-td-community]')) init(scope);
      scope.querySelectorAll?.('[data-td-community]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.('[data-td-community]')
        ? event.target
        : event.target.querySelector?.('[data-td-community]');
      controllers.get(root)?.abort();
      controllers.delete(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-custom-spaces-011"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initializeCustomSpaces(section) {
      if (!section || section.dataset.spacesInitialized === 'true') return;
      section.dataset.spacesInitialized = 'true';

      const track = section.querySelector('[data-spaces-track]');
      const openButton = section.querySelector('[data-spaces-open]');
      const closeButton = section.querySelector('[data-spaces-close]');
      const overlay = section.querySelector('[data-spaces-overlay]');
      const drawer = section.querySelector('[data-spaces-drawer]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobilePeek = window.matchMedia('(max-width: 479px)');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let offset = 0;
      let velocity = 0;
      let dragging = false;
      let dragStartX = 0;
      let dragStartOffset = 0;
      let lastX = 0;
      let lastTime = 0;
      let frame = 0;
      let previousFocus = null;
      let previousOverflow = '';
      let wasMobilePeek = mobilePeek.matches;

      const halfWidth = () => {
        if (!track || track.children.length < 2) return 0;
        const midpoint = track.children.length / 2;
        return track.children[midpoint].offsetLeft - track.children[0].offsetLeft;
      };
      const wrap = () => {
        const width = halfWidth();
        if (!width) return;
        while (offset <= -width) offset += width;
        while (offset > 0) offset -= width;
      };

      const animate = () => {
        if (!section.isConnected) return;
        if (track && halfWidth() > 0) {
          if (mobilePeek.matches && !wasMobilePeek) { offset = 0; velocity = 0; }
          if (!mobilePeek.matches && wasMobilePeek) track.style.transition = '';
          wasMobilePeek = mobilePeek.matches;
          if (!dragging && !reducedMotion.matches && !mobilePeek.matches) {
            if (Math.abs(velocity) > .1) {
              offset += velocity;
              velocity *= .95;
            } else {
              velocity = 0;
              offset -= Number(section.style.getPropertyValue('--td-spaces-speed')) || .8;
            }
          }
          wrap();
          track.style.transform = `translate3d(${offset.toFixed(2)}px, 0, 0)`;
        }
        frame = window.requestAnimationFrame(animate);
      };

      const closeMenu = () => {
        if (!section.classList.contains('is-menu-open')) return;
        section.classList.remove('is-menu-open');
        openButton?.setAttribute('aria-expanded', 'false');
        overlay?.setAttribute('aria-hidden', 'true');
        drawer?.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = previousOverflow;
        previousFocus?.focus();
      };

      const openMenu = () => {
        if (section.classList.contains('is-menu-open')) return;
        previousFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        section.classList.add('is-menu-open');
        openButton?.setAttribute('aria-expanded', 'true');
        overlay?.setAttribute('aria-hidden', 'false');
        drawer?.setAttribute('aria-hidden', 'false');
        closeButton?.focus();
      };

      openButton?.addEventListener('click', openMenu, options);
      closeButton?.addEventListener('click', closeMenu, options);
      overlay?.addEventListener('click', closeMenu, options);
      drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu, options));
      section.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMenu();
        if (event.key !== 'Tab' || !section.classList.contains('is-menu-open') || !drawer) return;
        const focusable = Array.from(drawer.querySelectorAll('a, button')).filter((element) => element.getClientRects().length);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);

      track?.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 && event.pointerType === 'mouse') return;
        dragging = true;
        if (mobilePeek.matches) track.style.transition = '';
        velocity = 0;
        dragStartX = event.clientX;
        dragStartOffset = offset;
        lastX = event.clientX;
        lastTime = event.timeStamp;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      }, options);

      track?.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const dt = Math.max(1, event.timeStamp - lastTime);
        const dx = event.clientX - lastX;
        velocity = dx / dt * 16;
        offset = dragStartOffset + event.clientX - dragStartX;
        lastX = event.clientX;
        lastTime = event.timeStamp;
      }, options);

      const endDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        if (mobilePeek.matches && track.children.length > 1) {
          const step = track.children[1].offsetLeft - track.children[0].offsetLeft;
          if (step) {
            offset = Math.round(offset / step) * step;
            wrap();
            if (!reducedMotion.matches) track.style.transition = 'transform .25s ease-out';
          }
        }
        if (track?.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        track?.classList.remove('is-dragging');
      };
      track?.addEventListener('pointerup', endDrag, options);
      track?.addEventListener('pointercancel', endDrag, options);
      track?.addEventListener('lostpointercapture', () => { dragging = false; track.classList.remove('is-dragging'); }, options);
      frame = window.requestAnimationFrame(animate);

      section._tdCustomSpacesCleanup = () => {
        closeMenu();
        controller.abort();
        window.cancelAnimationFrame(frame);
      };
    }

    const initializeAll = (root = document) => {
      if (root.matches?.('[data-td-custom-spaces]')) initializeCustomSpaces(root);
      root.querySelectorAll?.('[data-td-custom-spaces]').forEach(initializeCustomSpaces);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches?.('[data-td-custom-spaces]') ? event.target : event.target.querySelector?.('[data-td-custom-spaces]');
      section?._tdCustomSpacesCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-customization-education"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-selector-media-config')) {
    customElements.define('td-selector-media-config', class extends HTMLElement {
      connectedCallback() {
        this.sources = [
          { manual: this.dataset.miniManualUrl, colors: { White: this.dataset.miniWhiteUrl, Black: this.dataset.miniBlackUrl, 'Dark Green': this.dataset.miniGreenUrl } },
          { manual: this.dataset.luggageManualUrl, colors: { Black: this.dataset.luggageBlackUrl, White: this.dataset.luggageWhiteUrl } },
          // Bottle images come from each exact Shopify variant, never the product-wide hero or legacy neutral image.
          { colors: {} },
        ];
        window.__tdSelectorImageResolver = (handle, color, fallback = '') => {
          const index = handle === 'cross-body-bag' ? 0 : handle === 'traveldepot-20-hardshell-carry-on-luggage' ? 1 : handle === 'traveldepot-900ml-travel-bottle' ? 2 : -1;
          const config = this.sources[index];
          return config?.manual || config?.colors[color] || fallback;
        };
        if (!window.__tdSelectorFetchPatched) {
          window.__tdSelectorFetchPatched = true;
          const nativeFetch = window.fetch.bind(window);
          window.fetch = async (...args) => {
            const response = await nativeFetch(...args);
            const requestUrl = new URL(typeof args[0] === 'string' ? args[0] : args[0]?.url || '', location.href);
            const match = requestUrl.pathname.match(/\/products\/([^/]+)\.js$/);
            if (!match || !window.__tdSelectorImageResolver || !response.ok) return response;
            const handle = decodeURIComponent(match[1]);
            if (!['cross-body-bag', 'traveldepot-20-hardshell-carry-on-luggage', 'traveldepot-900ml-travel-bottle'].includes(handle)) return response;
            const product = await response.clone().json();
            const options = product.options || [];
            const colorIndex = options.findIndex((option) => /colou?r/i.test(typeof option === 'string' ? option : option.name));
            const colorFor = (variant) => variant['option' + (colorIndex < 0 ? 1 : colorIndex + 1)] || variant.title || 'Default';
            product.variants = (product.variants || []).map((variant) => ({
              ...variant,
              featured_image: window.__tdSelectorImageResolver(handle, colorFor(variant), variant.featured_image),
            }));
            const initial = product.variants.find((variant) => variant.available) || product.variants[0];
            product.featured_image = initial?.featured_image || product.featured_image;
            return new Response(JSON.stringify(product), {
              status: response.status,
              statusText: response.statusText,
              headers: { 'Content-Type': 'application/json; charset=utf-8' },
            });
          };
        }
        document.documentElement.style.setProperty('--td-selector-media-background', this.dataset.background || '#f3f2ef');
        this.apply = this.apply.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.observer = new MutationObserver(this.apply);
        this.observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
        document.addEventListener('click', this.handleClick, true);
        this.apply();
      }
      disconnectedCallback() { this.observer?.disconnect(); document.removeEventListener('click', this.handleClick, true); }
      handleClick(event) {
        if (!event.target.closest('#traveldepot-personalize .td-personalize__swatch')) return;
        requestAnimationFrame(() => requestAnimationFrame(this.apply));
      }
      apply() {
        const selector = document.getElementById('traveldepot-personalize');
        if (!selector) return;
        const cards = [...selector.querySelectorAll('.td-personalize__product')];
        if (!this.miniDefaultSynced && this.dataset.miniDefaultColor && cards[0]) {
          this.miniDefaultSynced = true;
          const swatch = [...cards[0].querySelectorAll('.td-personalize__swatch')].find((button) => (button.dataset.tdColor || button.getAttribute('aria-label')) === this.dataset.miniDefaultColor);
          swatch?.click();
        }
        cards.forEach((card, index) => {
          const image = card.querySelector('.td-personalize__image');
          const colorNode = card.querySelector('.td-personalize__color-label strong');
          const color = colorNode?.dataset.tdColor || colorNode?.textContent?.trim();
          const sourceConfig = this.sources[index];
          const source = sourceConfig?.manual || sourceConfig?.colors[color];
          if (!image || !source || image.src === new URL(source, location.href).href) return;
          image.src = source;
          image.dataset.tdSelectorSource = source;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-editorial-orbit-original"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const mix = (from, to, progress) => from + (to - from) * progress;

    const interpolate = (value, stops, values) => {
      if (value <= stops[0]) return values[0];
      const last = stops.length - 1;
      if (value >= stops[last]) return values[last];
      for (let index = 0; index < last; index += 1) {
        if (value <= stops[index + 1]) {
          const local = (value - stops[index]) / (stops[index + 1] - stops[index]);
          return mix(values[index], values[index + 1], local);
        }
      }
      return values[last];
    };

    const findScrollRoot = (element) => {
      let parent = element.parentElement;
      while (parent && parent !== document.body) {
        const styles = getComputedStyle(parent);
        if (/(auto|scroll)/.test(styles.overflowY) && parent.scrollHeight > parent.clientHeight) return parent;
        parent = parent.parentElement;
      }
      return window;
    };

    const initializeCover = (section) => {
      const wrapper = section.closest('.shopify-section');
      if (!wrapper) return () => {};
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let previous = null;
      let frame = 0;
      let reconnect = true;

      const reset = () => {
        previous?.classList.remove('td-original-orbit-cover-source');
        previous?.style.removeProperty('--td-cover-y');
        wrapper.classList.remove('td-original-orbit-cover-target');
        delete section.dataset.orbitCover;
      };
      const renderCover = () => {
        frame = 0;
        if (reconnect) {
          reset();
          const sibling = wrapper.previousElementSibling;
          previous = sibling?.classList.contains('shopify-section') && sibling.querySelector(':scope > .hero') ? sibling : null;
          reconnect = false;
        }
        if (!previous || !previous.isConnected || reduced.matches) {
          reset();
          return;
        }
        previous.classList.add('td-original-orbit-cover-source');
        wrapper.classList.add('td-original-orbit-cover-target');
        const activeRoot = findScrollRoot(section);
        const rootTop = activeRoot === window ? 0 : activeRoot.getBoundingClientRect().top;
        const headerBottom = document.querySelector('#header-component')?.getBoundingClientRect().bottom ?? rootTop;
        const pinTop = Math.max(rootTop, headerBottom);
        const before = previous.getBoundingClientRect();
        const incoming = section.getBoundingClientRect();
        // Once Orbit reaches the header, the hero is fully covered and can return to normal flow.
        const covering = before.top < pinTop && incoming.top > pinTop;
        previous.style.setProperty('--td-cover-y', covering ? `${(pinTop - before.top).toFixed(3)}px` : '0px');
        section.dataset.orbitCover = incoming.top <= pinTop ? 'complete' : covering ? 'covering' : 'idle';
      };
      const queueCover = () => {
        if (!frame) frame = requestAnimationFrame(renderCover);
      };
      const layoutChanged = () => { reconnect = true; queueCover(); };
      window.addEventListener('scroll', queueCover, { passive: true, capture: true });
      window.addEventListener('resize', queueCover, { passive: true });
      reduced.addEventListener('change', layoutChanged);
      document.addEventListener('shopify:section:load', layoutChanged);
      document.addEventListener('shopify:section:reorder', layoutChanged);
      document.addEventListener('shopify:section:unload', layoutChanged);
      renderCover();
      return () => {
        if (frame) cancelAnimationFrame(frame);
        window.removeEventListener('scroll', queueCover, true);
        window.removeEventListener('resize', queueCover);
        reduced.removeEventListener('change', layoutChanged);
        document.removeEventListener('shopify:section:load', layoutChanged);
        document.removeEventListener('shopify:section:reorder', layoutChanged);
        document.removeEventListener('shopify:section:unload', layoutChanged);
        reset();
      };
    };

    const initialize = (section) => {
      if (!section || instances.has(section)) return;

      const stage = section.querySelector('.td-original-orbit__stage');
      const viewport = section.querySelector('[data-orbit-viewport]');
      const design = section.querySelector('[data-orbit-design]');
      const rotator = section.querySelector('[data-orbit-rotator]');
      const items = Array.from(section.querySelectorAll('[data-orbit-item]'));
      const mobileCopies = Array.from(section.querySelectorAll('[data-orbit-mobile-copy]'));
      if (!stage || !viewport || !design || !rotator || items.length === 0) return;

      const scrollRoot = findScrollRoot(section);
      const cleanupCover = initializeCover(section);
      let frame = 0;
      let previousScroll = 0;
      let visible = true;
      let designScale = 1;
      let editorSelectedIndex = -1;

      const progress = () => {
        const rect = section.getBoundingClientRect();
        const rootRect = scrollRoot === window ? { top: 0 } : scrollRoot.getBoundingClientRect();
        const viewportHeight = scrollRoot === window ? window.innerHeight : scrollRoot.clientHeight;
        return clamp(-(rect.top - rootRect.top) / Math.max(1, section.offsetHeight - viewportHeight));
      };

      previousScroll = progress();

      const updateScale = () => {
        designScale = viewport.clientWidth / 800;
        design.style.setProperty('--td-design-scale', designScale.toFixed(6));
        section.style.setProperty('--td-mobile-copy-width', `${Math.min(window.innerWidth * .82, 320) / Math.max(.01, designScale)}px`);
        section.style.setProperty('--td-mobile-copy-y', `${(110 + 28) / Math.max(.01, designScale)}px`);
        section.style.setProperty('--td-mobile-title-gap', `${12 / Math.max(.01, designScale)}px`);
        section.style.setProperty('--td-mobile-title-size', `${30 / Math.max(.01, designScale)}px`);
        section.style.setProperty('--td-mobile-description-size', `${14 / Math.max(.01, designScale)}px`);
      };

      const stageIsVisible = () => {
        const rect = stage.getBoundingClientRect();
        const rootRect = scrollRoot === window ? { top: 0, bottom: window.innerHeight } : scrollRoot.getBoundingClientRect();
        return rect.bottom > rootRect.top && rect.top < rootRect.bottom;
      };

      const render = (now) => {
        frame = 0;
        if (!visible || document.hidden) return;

        const position = progress();
        previousScroll = position;

        let reveal = interpolate(position, [0, .08, 1], [0, 55, 55]);
        let textOpacity = interpolate(position, [.03, .08, .15, .22, .90, .98, 1], [0, 1, 1, 0, 0, 1, 1]);
        const textBlur = interpolate(position, [.03, .08, .15, .22, .90, .98, 1], [15, 0, 0, 15, 15, 0, 0]);
        const textY = interpolate(position, [.03, .08, .15, .22, .90, .98, 1], [20, 0, 0, 20, 20, 0, 0]);
        const hintOpacity = interpolate(position, [0, .03, .08], [1, 1, 0]);
        const stops = [.15, .25, .85, .95, 1];
        const focusedVisualSize = window.innerWidth <= 749 ? 220 : 360;
        const focusedItemSize = focusedVisualSize / Math.max(.01, designScale);
        let itemSize = interpolate(position, stops, [80, focusedItemSize, focusedItemSize, 80, 80]);
        let radiusX = interpolate(position, stops, [330, 650, 650, 330, 330]);
        let radiusY = interpolate(position, stops, [140, 650, 650, 140, 140]);
        let rotation = interpolate(position, stops, [-15, 0, 0, -15, -15]);
        let translateX = interpolate(position, stops, [0, -850, -850, 0, 0]);
        let focusStrength = interpolate(position, stops, [0, 1, 1, 0, 0]);
        const orbitTravel = items.length > 1 ? ((items.length - 1) / items.length) * 100 : 0;
        let orbitProgress = position <= .15
          ? 0
          : position < .25
            ? mix(0, -50, (position - .15) / .10)
            : position <= .85
              ? -50 - ((position - .25) / .60) * orbitTravel
              : -50 - orbitTravel;
        if (editorSelectedIndex >= 0) {
          reveal = 55;
          textOpacity = 0;
          itemSize = focusedItemSize;
          radiusX = 650;
          radiusY = 650;
          rotation = 0;
          translateX = -850;
          focusStrength = 1;
          orbitProgress = 50 - (editorSelectedIndex / items.length) * 100;
        }
        const path = `path("M ${400 - radiusX} 400 A ${radiusX} ${radiusY} 0 1 0 ${400 + radiusX} 400 A ${radiusX} ${radiusY} 0 1 0 ${400 - radiusX} 400")`;

        section.style.setProperty('--td-reveal-x', `${reveal}%`);
        section.style.setProperty('--td-reveal-y', `${reveal}%`);
        section.style.setProperty('--td-text-opacity', textOpacity.toFixed(4));
        section.style.setProperty('--td-text-blur', `${textBlur.toFixed(3)}px`);
        section.style.setProperty('--td-text-y', `${textY.toFixed(3)}px`);
        section.style.setProperty('--td-scroll-hint-opacity', hintOpacity.toFixed(4));
        rotator.style.setProperty('--td-orbit-x', `${translateX.toFixed(3)}px`);
        rotator.style.setProperty('--td-orbit-rotation', `${rotation.toFixed(3)}deg`);
        rotator.style.setProperty('--td-orbit-path', path);

        items.forEach((item, index) => {
          const raw = ((orbitProgress + index / items.length * 100) % 100 + 100) % 100;
          let distance = Math.abs(raw - 50);
          if (distance > 50) distance = 100 - distance;
          let targetScale = .4;
          if (distance < 20) {
            const ratio = distance / 20;
            targetScale = .4 + (Math.cos(ratio * Math.PI) + 1) / 2 * .6;
          }
          const itemScale = 1 - focusStrength * (1 - targetScale);
          const labelFocus = clamp((targetScale - .72) / .28);
          const itemFocus = focusStrength * labelFocus;
          const configuredFocusScale = window.innerWidth <= 749
            ? Number.parseFloat(item.dataset.mobileFocusScale || '1')
            : Number.parseFloat(item.dataset.desktopFocusScale || '1');
          const focusAssetScale = mix(1, configuredFocusScale, itemFocus);
          const configuredMobileOffsetX = window.innerWidth <= 749
            ? Number.parseFloat(item.dataset.mobileFocusOffsetX || '0')
            : 0;
          const focusOffsetX = configuredMobileOffsetX * itemFocus / Math.max(.01, designScale);
          item.style.setProperty('--td-item-size', `${itemSize.toFixed(3)}px`);
          item.style.setProperty('--td-item-distance', `${raw.toFixed(4)}%`);
          item.style.setProperty('--td-item-scale', itemScale.toFixed(5));
          item.style.setProperty('--td-item-z', `${Math.round(itemScale * 100)}`);
          item.style.setProperty('--td-item-counter-rotation', `${(-rotation).toFixed(3)}deg`);
          item.style.setProperty('--td-focus-asset-scale', focusAssetScale.toFixed(5));
          item.style.setProperty('--td-focus-offset-x', `${focusOffsetX.toFixed(3)}px`);
          item.style.setProperty('--td-label-opacity', (focusStrength * labelFocus).toFixed(4));
          if (mobileCopies[index]) {
            mobileCopies[index].style.setProperty('--td-mobile-copy-opacity', (focusStrength * labelFocus).toFixed(4));
          }
        });

        frame = requestAnimationFrame(render);
      };

      const wake = () => {
        if (frame || !visible || document.hidden) return;
        previousScroll = progress();
        frame = requestAnimationFrame(render);
      };

      const syncVisibility = () => {
        visible = stageIsVisible();
        if (frame) {
          cancelAnimationFrame(frame);
          frame = 0;
        }
        if (visible && !document.hidden) {
          frame = requestAnimationFrame(render);
        }
      };

      const resizeObserver = new ResizeObserver(updateScale);
      resizeObserver.observe(viewport);
      updateScale();

      const intersectionObserver = new IntersectionObserver((entries) => {
        visible = entries.some((entry) => entry.isIntersecting);
        if (visible) wake();
        else if (frame) {
          cancelAnimationFrame(frame);
          frame = 0;
        }
      }, { root: scrollRoot === window ? null : scrollRoot });
      intersectionObserver.observe(stage);

      const scrollTarget = scrollRoot === window ? window : scrollRoot;
      scrollTarget.addEventListener('scroll', syncVisibility, { passive: true });
      window.addEventListener('resize', syncVisibility, { passive: true });

      const visibilityHandler = () => {
        if (document.hidden && frame) {
          cancelAnimationFrame(frame);
          frame = 0;
        } else wake();
      };
      const blockSelectHandler = (event) => {
        const item = event.target.closest?.('[data-orbit-item]');
        if (!item || !section.contains(item)) return;
        editorSelectedIndex = items.indexOf(item);
        visible = true;
        wake();
      };
      const blockDeselectHandler = (event) => {
        const item = event.target.closest?.('[data-orbit-item]');
        if (!item || !section.contains(item)) return;
        editorSelectedIndex = -1;
        wake();
      };
      document.addEventListener('visibilitychange', visibilityHandler);
      document.addEventListener('shopify:block:select', blockSelectHandler);
      document.addEventListener('shopify:block:deselect', blockDeselectHandler);
      frame = requestAnimationFrame(render);

      instances.set(section, () => {
        cleanupCover();
        if (frame) cancelAnimationFrame(frame);
        resizeObserver.disconnect();
        intersectionObserver.disconnect();
        scrollTarget.removeEventListener('scroll', syncVisibility);
        window.removeEventListener('resize', syncVisibility);
        document.removeEventListener('visibilitychange', visibilityHandler);
        document.removeEventListener('shopify:block:select', blockSelectHandler);
        document.removeEventListener('shopify:block:deselect', blockDeselectHandler);
        instances.delete(section);
      });
    };

    const initializeWithin = (root = document) => {
      if (root.matches?.('[data-td-original-orbit]')) initialize(root);
      root.querySelectorAll?.('[data-td-original-orbit]').forEach(initialize);
    };

    initializeWithin();
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches?.('[data-td-original-orbit]') ? event.target : event.target.querySelector?.('[data-td-original-orbit]');
      instances.get(section)?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-floating-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-floating-rail')) {
    customElements.define('td-floating-rail', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.scrollListenerController = null;
        this.addEventListener('click', (event) => this.handleClick(event), { signal });
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.closePanels();
        }, { signal });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.closePanels(true);
        }, { signal });
        this.connectScrollRoot();
        const result = this.querySelector('[data-rail-form-result]');
        if (result) this.openPanel(result.closest('[data-rail-panel]')?.id);
        const promo = this.querySelector('[data-promo]');
        if (promo && this.dataset.editor !== 'true') {
          try { if (sessionStorage.getItem('td-floating-rail-promo-hidden') === '1') promo.hidden = true; } catch (_) {}
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.scrollListenerController?.abort();
      }
      async connectScrollRoot() {
        try {
          this.scrollApi = await import('@theme/scroll-container');
        } catch (_) {
          this.scrollApi = null;
        }
        if (!this.isConnected) return;

        this.handleScrollRootChange = () => this.bindScrollRoot();
        this.scrollApi?.scrollContainerMediaQuery.addEventListener('change', this.handleScrollRootChange, {
          signal: this.controller.signal,
        });
        this.bindScrollRoot();
      }
      bindScrollRoot() {
        this.scrollListenerController?.abort();
        this.scrollListenerController = new AbortController();
        const scrollTarget = this.scrollApi?.getScrollEventTarget() || document;
        scrollTarget.addEventListener('scroll', () => this.updateTop(), {
          passive: true,
          signal: this.scrollListenerController.signal,
        });
        this.updateTop();
      }
      updateTop() {
        const item = this.querySelector('[data-top-item]');
        const scrollPosition = this.scrollApi?.getScrollTop() ?? window.scrollY;
        if (item) item.hidden = scrollPosition < Number(this.dataset.topThreshold || 500) && this.dataset.editor !== 'true';
      }
      closePanels(restoreFocus = false) {
        this.querySelectorAll('[data-rail-panel]').forEach((panel) => { panel.hidden = true; });
        this.querySelectorAll('[data-panel-id]').forEach((button) => {
          const wasOpen = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', 'false');
          if (restoreFocus && wasOpen) button.focus();
        });
      }
      openPanel(id) {
        const panel = id && this.querySelector('#' + CSS.escape(id));
        if (!panel) return;
        this.closePanels();
        panel.hidden = false;
        this.querySelector('[data-panel-id="' + CSS.escape(id) + '"]')?.setAttribute('aria-expanded', 'true');
        panel.querySelector('[data-rail-action="close"]')?.focus();
      }
      handleClick(event) {
        const action = event.target.closest('[data-rail-action]');
        if (!action || !this.contains(action)) return;
        if (action.dataset.railAction === 'toggle') {
          const panel = this.querySelector('#' + CSS.escape(action.dataset.panelId));
          if (panel?.hidden) this.openPanel(action.dataset.panelId);
          else this.closePanels();
        } else if (action.dataset.railAction === 'close') {
          this.closePanels(true);
        } else if (action.dataset.railAction === 'dismiss') {
          action.closest('[data-promo]').hidden = true;
          try { sessionStorage.setItem('td-floating-rail-promo-hidden', '1'); } catch (_) {}
        } else if (action.dataset.railAction === 'top') {
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          if (this.scrollApi) this.scrollApi.scrollTo({ top: 0, behavior });
          else window.scrollTo({ top: 0, behavior });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-home-lifestyle-close"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const imageJobs = new WeakMap();
    const readyImages = new WeakSet();
    const prepareImage = (image) => {
      if (!image) return Promise.resolve(true);
      if (imageJobs.has(image)) return imageJobs.get(image);
      const job = new Promise((resolve) => {
        let settled = false;
        const finish = (ok) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          image.removeEventListener('load', loaded);
          image.removeEventListener('error', failed);
          if (ok) readyImages.add(image);
          resolve(ok);
        };
        const loaded = () => {
          if (!image.naturalWidth) return finish(false);
          if (image.decode) image.decode().then(() => finish(true), () => finish(false));
          else finish(true);
        };
        const failed = () => finish(false);
        const timer = setTimeout(() => finish(false), 10000);
        image.addEventListener('load', loaded, { once: true });
        image.addEventListener('error', failed, { once: true });
        image.loading = 'eager';
        if (image.complete && image.naturalWidth) loaded();
      });
      imageJobs.set(image, job);
      job.then(() => imageJobs.delete(image));
      return job;
    };
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-td-home-lifestyle]').forEach((root) => {
        if (root.dataset.imagesPrepared) return;
        root.dataset.imagesPrepared = 'true';
        const observer = new IntersectionObserver(async (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          for (const image of root.querySelectorAll('img')) {
            if (!root.isConnected) return;
            image.fetchPriority = 'low';
            await prepareImage(image);
          }
        }, { rootMargin: '800px 0px' });
        observer.observe(root);
        const unload = (event) => {
          if (!event.target.contains(root)) return;
          observer.disconnect();
          document.removeEventListener('shopify:section:unload', unload);
        };
        document.addEventListener('shopify:section:unload', unload);
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-in-the-wild"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tracks = [...root.querySelectorAll('.td-wild__track')];
      const dialog = root.querySelector('.td-wild__dialog');
      const dialogMedia = root.querySelector('.td-wild__dialog-media');
      const closeButton = root.querySelector('.td-wild__dialog-close');
      const duration = Math.max(20, Number(root.dataset.duration || 48));
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = matchMedia('(max-width: 749px)');
      const originalCards = [...root.querySelectorAll('.td-wild__card')];
      const canAutoLoop = originalCards.length >= 6 && !reducedMotion.matches;
      let paused = false;
      let inView = false;
      let lastTime;
      const states = tracks.map((track, index) => {
        const originals = [...track.querySelectorAll('.td-wild__card')];
        if (canAutoLoop) {
          originals.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.dataset.tdClone = 'true';
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            clone.removeAttribute('data-shopify-editor-block');
            track.appendChild(clone);
          });
        }
        return { track, originals, direction: index === 0 ? 1 : -1, position: 0, cycle: 0, initialized: false };
      });

      const measure = (state) => {
        const gap = parseFloat(getComputedStyle(state.track).columnGap || getComputedStyle(state.track).gap || 0);
        state.cycle = state.originals.reduce((total, card) => total + card.getBoundingClientRect().width, 0) + gap * state.originals.length;
        if (!state.initialized && state.cycle > 0) {
          state.position = state.direction < 0 ? state.cycle : 0;
          state.track.scrollLeft = state.position;
          state.initialized = true;
        }
      };

      const animate = (time) => {
        const delta = lastTime ? Math.min(40, time - lastTime) : 0;
        lastTime = time;
        if (canAutoLoop && inView && !paused && !mobile.matches && !document.hidden) {
          states.forEach((state) => {
            measure(state);
            if (state.cycle <= 0) return;
            state.position += (state.cycle / (duration * 1000)) * delta * state.direction;
            if (state.position >= state.cycle) state.position -= state.cycle;
            if (state.position <= 0 && state.direction < 0) state.position += state.cycle;
            state.track.scrollLeft = state.position;
          });
        }
        requestAnimationFrame(animate);
      };
      if (root.dataset.pauseHover === 'true') {
        root.addEventListener('mouseenter', () => { paused = true; });
        root.addEventListener('mouseleave', () => { paused = false; });
      }
      root.addEventListener('focusin', () => { paused = true; });
      root.addEventListener('focusout', () => { paused = false; });
      root.addEventListener('pointerdown', (event) => { if (event.pointerType !== 'mouse') paused = true; });
      root.addEventListener('pointerup', (event) => { if (event.pointerType !== 'mouse') paused = false; });
      new IntersectionObserver((entries) => { inView = Boolean(entries[0]?.isIntersecting); }, { rootMargin: '20% 0px', threshold: 0 }).observe(root);

      const videos = [...root.querySelectorAll('.td-wild__card video')];
      if (videos.length) {
        const visibleVideos = new Map();
        const syncVideos = () => {
          const allowed = [...visibleVideos.entries()]
            .filter(([, ratio]) => ratio >= .35)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 2)
            .map(([video]) => video);
          videos.forEach((video) => {
            if (allowed.includes(video) && !reducedMotion.matches && !document.hidden) video.play().catch(() => {});
            else video.pause();
          });
        };
        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => visibleVideos.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
          syncVideos();
        }, { threshold: [0, .35, .6, 1] });
        videos.forEach((video) => videoObserver.observe(video));
        document.addEventListener('visibilitychange', syncVideos);
      }

      root.querySelectorAll('.td-wild__card').forEach((card) => card.addEventListener('click', () => {
        if (!dialog || !dialogMedia || !dialog.showModal) return;
        const source = card.querySelector('.td-wild__media-frame');
        dialogMedia.innerHTML = source ? source.innerHTML : '';
        dialogMedia.querySelectorAll('video').forEach((video) => { video.controls = true; video.muted = false; video.play().catch(() => {}); });
        dialog.showModal();
      }));
      const closeDialog = () => { if (!dialog?.open) return; dialog.querySelectorAll('video').forEach((video) => video.pause()); dialog.close(); dialogMedia.innerHTML = ''; };
      closeButton?.addEventListener('click', closeDialog);
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
      addEventListener('resize', () => states.forEach((state) => { state.initialized = false; measure(state); }), { passive: true });
      requestAnimationFrame(animate);
    };
    document.querySelectorAll('.td-wild').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.td-wild')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-journey-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.journeyReady === 'true') return;
      section.dataset.journeyReady = 'true';
      const chapters = [...section.querySelectorAll('[data-journey-chapter]')];
      const media = [...section.querySelectorAll('[data-journey-media]')];
      const nav = [...section.querySelectorAll('[data-journey-nav]')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const activate = (index) => {
        chapters.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
        media.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', String(!active));
          const video = item.querySelector('video');
          if (!video) return;
          if (active && !reducedMotion) video.play().catch(() => {});
          else video.pause();
        });
        nav.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', String(active));
        });
      };

      nav.forEach((button) => button.addEventListener('click', () => {
        const index = Number(button.dataset.journeyNav);
        activate(index);
        chapters[index]?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
      }));

      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) activate(Number(visible.target.dataset.journeyChapter));
      }, { rootMargin: '-28% 0px -28% 0px', threshold: [0, .2, .5, .75] });
      chapters.forEach((chapter) => observer.observe(chapter));

      const revealObserver = new IntersectionObserver((entries) => {
        if (entries[0]?.isIntersecting) {
          section.classList.add('is-visible');
          revealObserver.disconnect();
        }
      }, { threshold: .08 });
      revealObserver.observe(section);
      if (!section.dataset.reveal || section.dataset.reveal === 'false') section.classList.add('is-visible');
      activate(0);
    };

    document.querySelectorAll('.td-journey').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.td-journey')));
    document.addEventListener('shopify:block:select', (event) => {
      const chapter = event.target.closest('[data-journey-chapter]');
      const section = event.target.closest('.td-journey');
      if (!chapter || !section) return;
      section.querySelector(`[data-journey-nav="${chapter.dataset.journeyChapter}"]`)?.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-pdp-capacity"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('td-inside-card-motion')) {

 customElements.define('td-inside-card-motion',class extends HTMLElement {

  connectedCallback() {
   if(window.tdPdpEntryEnabled)return;

   this.controller=new AbortController();this.animations=new Map();

   this.cards=[...this.querySelectorAll('.td-inside-card')];

   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');

   const reveal=()=>this.reveal();

   this.addEventListener('focusin',reveal,{signal:this.controller.signal});

   this.addEventListener('shopify:block:select',reveal,{signal:this.controller.signal});

   this.reduced.addEventListener('change',e=>{if(e.matches)this.reveal();},{signal:this.controller.signal});

   if(this.reduced.matches || !('IntersectionObserver' in window) || !this.animate){this.reveal();return;}

   const mobile=matchMedia('(max-width:767px)').matches;

   this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{

    if(!entry.isIntersecting)return;

    this.observer.unobserve(entry.target);const a=this.animations.get(entry.target);

    if(a){entry.target.dataset.tdInsideMotion='playing';a.play();}

   }),{threshold:.15,rootMargin:'0px 0px -20px 0px'});

   this.cards.forEach((card,index)=>{

    const a=card.animate([{opacity:0,transform:'translateY(28px)'},{opacity:1,transform:'translateY(0)'}],{duration:600,delay:mobile?0:index*100,fill:'both',easing:'cubic-bezier(.22,1,.36,1)'});

    a.pause();this.animations.set(card,a);card.dataset.tdInsideMotion='ready';

    a.finished.then(()=>{if(this.animations.get(card)!==a)return;card.dataset.tdInsideMotion='done';a.cancel();this.animations.delete(card);}).catch(()=>{});

    this.observer.observe(card);

   });

  }

  reveal(){this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());this.animations?.clear();this.cards?.forEach(card=>{card.dataset.tdInsideMotion='visible';});}

  disconnectedCallback(){this.reveal();this.controller?.abort();}

 });

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-pdp-faq"] && !Shopify.designMode) return;
  try {
    
 if (!customElements.get('td-pdp-faq-motion')) {
  customElements.define('td-pdp-faq-motion', class extends HTMLElement {
   connectedCallback() {
    this.controller = new AbortController(); this.states = new Map();
    this.querySelectorAll('details').forEach(details => {
     const summary = details.querySelector('summary');
     summary.addEventListener('click', event => {
      event.preventDefault();
      const previous = this.states.get(details);
      const opening = previous ? !previous.opening : !details.open;
      const start = details.getBoundingClientRect().height;
      if (previous) previous.animation.cancel();
      details.open = true;
      const end = opening ? details.scrollHeight : summary.getBoundingClientRect().height;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
       details.open = opening; this.states.delete(details); return;
      }
      const animation = details.animate([{height: start + 'px'}, {height: end + 'px'}], {duration: 300, easing: 'cubic-bezier(.22,1,.36,1)'});
      this.states.set(details, {animation, opening});
      animation.finished.then(() => {
       if (this.states.get(details)?.animation !== animation) return;
       details.open = opening; this.states.delete(details);
      }).catch(() => {});
     }, {signal: this.controller.signal});
    });
   }
   disconnectedCallback() {
    this.controller?.abort(); this.states?.forEach(({animation,opening},details) => {animation.cancel(); details.open=opening;}); this.states?.clear();
   }
  });
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-product-parade"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const mix = (from, to, progress) => from + (to - from) * progress;

    function interpolate(value, stops, values) {
      if (value <= stops[0]) return values[0];
      const last = stops.length - 1;
      if (value >= stops[last]) return values[last];
      for (let index = 0; index < last; index += 1) {
        if (value <= stops[index + 1]) {
          const local = (value - stops[index]) / (stops[index + 1] - stops[index]);
          return mix(values[index], values[index + 1], local);
        }
      }
      return values[last];
    }

    function initializeOrbitStory(section) {
      if (!section || section.dataset.orbitInitialized === 'true') return;
      section.dataset.orbitInitialized = 'true';

      const stage = section.querySelector('[data-orbit-stage]');
      const canvas = section.querySelector('[data-orbit-canvas]');
      const items = Array.from(section.querySelectorAll('[data-orbit-item]'));
      const nextControl = section.querySelector('[data-orbit-next]');
      const videos = Array.from(section.querySelectorAll('video'));
      if (!stage || !canvas || items.length === 0) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const desktop = window.matchMedia('(min-width: 990px)');
      const orbitDuration = Math.max(10, Number(section.dataset.duration) || 40);
      let scrollRoot = window;
      let frame = 0;
      let animationFrame = 0;
      let lastTime = 0;
      let previousProgress = 0;
      let orbitProgress = 0;
      let stageVisible = true;

      const findScrollRoot = () => {
        let parent = section.parentElement;
        while (parent && parent !== document.body) {
          const styles = window.getComputedStyle(parent);
          if (/(auto|scroll)/.test(styles.overflowY) && parent.scrollHeight > parent.clientHeight) return parent;
          parent = parent.parentElement;
        }
        return window;
      };

      scrollRoot = findScrollRoot();

      const getProgress = () => {
        const rect = section.getBoundingClientRect();
        const rootRect = scrollRoot === window ? { top: 0 } : scrollRoot.getBoundingClientRect();
        const viewportHeight = scrollRoot === window ? window.innerHeight : scrollRoot.clientHeight;
        const distance = Math.max(1, section.offsetHeight - viewportHeight);
        return clamp(-(rect.top - rootRect.top) / distance);
      };

      const setVideoPlayback = (active) => {
        videos.forEach((video) => {
          if (active) video.play().catch(() => {});
          else video.pause();
        });
      };

      const placeItems = (progress, deltaTime = 0) => {
        const isDesktop = desktop.matches;
        const geometryStops = [0, .15, .25, .85, .95, 1];
        const compactRx = isDesktop ? 330 : 245;
        const compactRy = isDesktop ? 140 : 165;
        const expandedRadius = isDesktop ? 650 : 520;
        const compactSize = isDesktop ? 80 : 108;
        const expandedSize = isDesktop ? 360 : 286;
        const expandedTranslate = isDesktop ? -850 : -520;

        const rx = interpolate(progress, geometryStops, [compactRx, compactRx, expandedRadius, expandedRadius, compactRx, compactRx]);
        const ry = interpolate(progress, geometryStops, [compactRy, compactRy, expandedRadius, expandedRadius, compactRy, compactRy]);
        const itemSize = interpolate(progress, geometryStops, [compactSize, compactSize, expandedSize, expandedSize, compactSize, compactSize]);
        const rotation = interpolate(progress, geometryStops, [-15, -15, 0, 0, -15, -15]) * Math.PI / 180;
        const translateX = interpolate(progress, geometryStops, [0, 0, expandedTranslate, expandedTranslate, 0, 0]);
        const focusStrength = interpolate(progress, geometryStops, [0, 0, 1, 1, 0, 0]);

        const deltaProgress = progress - previousProgress;
        if (progress > .15 && progress < .85) orbitProgress += deltaProgress * 200;
        else if (stageVisible && !document.hidden && !reducedMotion.matches) orbitProgress += deltaTime / 1000 * 100 / orbitDuration;
        previousProgress = progress;

        const cosRotation = Math.cos(rotation);
        const sinRotation = Math.sin(rotation);

        items.forEach((item, index) => {
          const rawPosition = ((orbitProgress + index / items.length * 100) % 100 + 100) % 100;
          const angle = Math.PI + rawPosition / 100 * Math.PI * 2;
          const ellipseX = Math.cos(angle) * rx;
          const ellipseY = Math.sin(angle) * ry;
          const x = ellipseX * cosRotation - ellipseY * sinRotation + translateX;
          const y = ellipseX * sinRotation + ellipseY * cosRotation;

          let distance = Math.abs(rawPosition - 50);
          if (distance > 50) distance = 100 - distance;
          let focusedScale = .4;
          if (distance < 20) {
            const ratio = distance / 20;
            focusedScale = .4 + (Math.cos(ratio * Math.PI) + 1) / 2 * .6;
          }
          const depthScale = 1 - focusStrength * (1 - focusedScale);
          const imageScale = Number(item.dataset.imageScale) || 1;
          const labelOpacity = focusStrength * clamp((depthScale - .72) / .24);

          item.style.setProperty('--td-item-x', `${x.toFixed(2)}px`);
          item.style.setProperty('--td-item-y', `${y.toFixed(2)}px`);
          item.style.setProperty('--td-item-size', `${itemSize.toFixed(2)}px`);
          item.style.setProperty('--td-item-scale', depthScale.toFixed(3));
          item.style.setProperty('--td-item-z', `${Math.round(depthScale * 100)}`);
          item.style.setProperty('--td-image-scale', imageScale.toFixed(2));
          item.style.setProperty('--td-label-opacity', labelOpacity.toFixed(3));
        });
      };

      const render = (time = performance.now()) => {
        frame = 0;
        const deltaTime = lastTime ? Math.min(64, time - lastTime) : 0;
        lastTime = time;
        const progress = reducedMotion.matches ? .5 : getProgress();
        const reveal = interpolate(progress, [0, .08, 1], [0, 55, 55]);
        const chromeOpacity = interpolate(progress, [.03, .08, .15, .22, .90, .98, 1], [0, 1, 1, 0, 0, 1, 1]);
        const chromeBlur = interpolate(progress, [.03, .08, .15, .22, .90, .98, 1], [15, 0, 0, 15, 15, 0, 0]);
        const chromeY = interpolate(progress, [.03, .08, .15, .22, .90, .98, 1], [20, 0, 0, 20, 20, 0, 0]);
        const scrollOpacity = interpolate(progress, [0, .03, .08], [1, 1, 0]);

        section.style.setProperty('--td-reveal-rx', `${reveal.toFixed(3)}%`);
        section.style.setProperty('--td-reveal-ry', `${reveal.toFixed(3)}%`);
        section.style.setProperty('--td-chrome-opacity', chromeOpacity.toFixed(3));
        section.style.setProperty('--td-chrome-blur', `${chromeBlur.toFixed(2)}px`);
        section.style.setProperty('--td-chrome-y', `${chromeY.toFixed(2)}px`);
        section.style.setProperty('--td-scroll-opacity', scrollOpacity.toFixed(3));
        section.style.setProperty('--td-opening-copy-opacity', scrollOpacity.toFixed(3));
        section.style.setProperty('--td-opening-copy-y', `${(1 - scrollOpacity) * 16}px`);
        section.style.setProperty('--td-opening-scale', (1 + progress * .08).toFixed(3));
        placeItems(progress, deltaTime);
        setVideoPlayback(stageVisible && progress < .1 && !document.hidden);

        if (stageVisible && !document.hidden && !reducedMotion.matches && (progress <= .15 || progress >= .85)) {
          animationFrame = window.requestAnimationFrame(render);
        } else {
          animationFrame = 0;
        }
      };

      const requestRender = () => {
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        animationFrame = 0;
        if (frame) return;
        frame = window.requestAnimationFrame(render);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          stageVisible = entries.some((entry) => entry.isIntersecting);
          requestRender();
        }, { root: scrollRoot === window ? null : scrollRoot });
        observer.observe(stage);
      }

      scrollRoot.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender, { passive: true });
      desktop.addEventListener('change', requestRender);
      reducedMotion.addEventListener('change', requestRender);
      document.addEventListener('visibilitychange', requestRender);

      nextControl?.addEventListener('click', () => {
        const viewportHeight = scrollRoot === window ? window.innerHeight : scrollRoot.clientHeight;
        scrollRoot.scrollBy({ top: viewportHeight * .62, behavior: 'smooth' });
      });

      render();
    }

    const initializeAll = (root = document) => {
      if (root.matches?.('[data-td-orbit-story]')) initializeOrbitStory(root);
      root.querySelectorAll?.('[data-td-orbit-story]').forEach(initializeOrbitStory);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-review-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const slides = [...root.querySelectorAll('.td-stories__slide')];
      const tabs = [...root.querySelectorAll('.td-stories__tab')];
      const previous = root.querySelector('[data-action="previous"]');
      const next = root.querySelector('[data-action="next"]');
      if (!slides.length) return;
      const interval = Number(root.dataset.interval || 10000);
      root.style.setProperty('--td-story-interval', `${interval}ms`);
      let active = 0;
      let timer;
      let paused = false;
      let pointerStart = null;
      const playActiveMedia = () => slides.forEach((slide, index) => slide.querySelectorAll('video').forEach((video) => index === active ? video.play().catch(() => {}) : video.pause()));
      const show = (index, userInitiated = false) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => { const selected = slideIndex === active; slide.classList.toggle('is-active', selected); slide.setAttribute('aria-hidden', selected ? 'false' : 'true'); });
        tabs.forEach((tab, tabIndex) => { const selected = tabIndex === active; tab.classList.toggle('is-active', selected); tab.setAttribute('aria-selected', selected ? 'true' : 'false'); });
        playActiveMedia();
        if (userInitiated) restart();
      };
      const restart = () => { clearInterval(timer); if (root.dataset.autoplay === 'true' && !paused && !matchMedia('(prefers-reduced-motion: reduce)').matches && slides.length > 1) timer = setInterval(() => show(active + 1), interval); };
      tabs.forEach((tab) => tab.addEventListener('click', () => show(Number(tab.dataset.target), true)));
      previous?.addEventListener('click', () => show(active - 1, true));
      next?.addEventListener('click', () => show(active + 1, true));
      root.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') show(active - 1, true); if (event.key === 'ArrowRight') show(active + 1, true); });
      root.addEventListener('pointerdown', (event) => { if (event.pointerType !== 'mouse') pointerStart = event.clientX; });
      root.addEventListener('pointerup', (event) => { if (pointerStart === null) return; const distance = event.clientX - pointerStart; pointerStart = null; if (Math.abs(distance) > 55) show(active + (distance < 0 ? 1 : -1), true); });
      root.addEventListener('mouseenter', () => { paused = true; restart(); });
      root.addEventListener('mouseleave', () => { paused = false; restart(); });
      root.addEventListener('focusin', () => { paused = true; restart(); });
      root.addEventListener('focusout', () => { paused = false; restart(); });
      show(0);
      restart();
    };
    document.querySelectorAll('.td-stories').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.td-stories')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-sculpted-scroll"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const lerp = (current, target, amount) => current + (target - current) * amount;

    function initializeSculpted(section) {
      if (!section || section.dataset.sculptedInitialized === 'true') return;
      section.dataset.sculptedInitialized = 'true';

      const stage = section.querySelector('.td-sculpted__stage');
      const editorial = section.querySelector('[data-sculpted-editorial]');
      const progressBar = section.querySelector('[data-sculpted-progress]');
      const sheet = section.querySelector('[data-sculpted-sheet]');
      const backButton = section.querySelector('[data-sculpted-back]');
      const finalButton = section.querySelector('[data-scroll-final]');
      const videos = Array.from(section.querySelectorAll('.td-sculpted__video'));
      const mediaLayers = Array.from(section.querySelectorAll('[data-sculpted-layer]'));
      const productPanels = Array.from(section.querySelectorAll('[data-panel-product]'));
      const staggerItems = Array.from(section.querySelectorAll('[data-stagger]')).map((item) => {
        const [start, end] = item.dataset.stagger.split(',').map(Number);
        return { item, start, end };
      });
      const quantityOutput = section.querySelector('[data-quantity]');
      const priceOutput = section.querySelector('[data-total-price]');
      const addButton = section.querySelector('[data-sculpted-add]');
      const addStatus = section.querySelector('[data-add-status]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let scrollRoot = window;
      let targetScrollFraction = 0;
      let currentScrollFraction = 0;
      let targetVideoRatio = 0;
      let currentVideoTime = 0;
      let targetVideoSecondRatio = 0;
      let currentVideoSecondTime = 0;
      let quantity = 1;
      let isSecondCard = false;
      let isSheetOpen = false;
      let isVisible = true;
      let lastRenderedProgress = -1;
      let lastSeekTimes = [0, 0];
      let frameId = 0;
      let timeoutId = 0;

      if (!stage || videos.length < 2) return;

      const findScrollRoot = () => {
        let parent = section.parentElement;
        while (parent && parent !== document.body) {
          const styles = window.getComputedStyle(parent);
          if (/(auto|scroll)/.test(styles.overflowY) && parent.scrollHeight > parent.clientHeight) return parent;
          parent = parent.parentElement;
        }
        return window;
      };

      scrollRoot = findScrollRoot();

      const updateTarget = () => {
        const rect = section.getBoundingClientRect();
        const rootTop = scrollRoot === window ? 0 : scrollRoot.getBoundingClientRect().top;
        const viewportHeight = scrollRoot === window ? window.innerHeight : scrollRoot.clientHeight;
        const distance = Math.max(1, section.offsetHeight - viewportHeight);
        targetScrollFraction = clamp(-(rect.top - rootTop) / distance);
      };

      const updateLayout = () => {
        const siteHeader = document.querySelector('header-component');
        const headerHeight = siteHeader ? siteHeader.getBoundingClientRect().height : 0;
        const previewBarHeight = document.getElementById('PBarNextFrame') ? 64 : 0;
        section.style.setProperty('--td-site-header-offset', `${Math.max(0, headerHeight).toFixed(2)}px`);
        section.style.setProperty('--td-preview-bar-offset', `${previewBarHeight}px`);
        updateTarget();
      };

      const scrollToProgress = (progress) => {
        const viewportHeight = scrollRoot === window ? window.innerHeight : scrollRoot.clientHeight;
        const distance = Math.max(1, section.offsetHeight - viewportHeight);
        if (scrollRoot === window) {
          const sectionTop = window.scrollY + section.getBoundingClientRect().top;
          window.scrollTo({ top: sectionTop + distance * progress, behavior: 'smooth' });
        } else {
          const rootRect = scrollRoot.getBoundingClientRect();
          const sectionTop = scrollRoot.scrollTop + section.getBoundingClientRect().top - rootRect.top;
          scrollRoot.scrollTo({ top: sectionTop + distance * progress, behavior: 'smooth' });
        }
      };

      const formatPrice = (value) => {
        const currency = section.dataset.currency || 'USD';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency,
            maximumFractionDigits: 0
          }).format(value);
        } catch (error) {
          return `$${Math.round(value).toLocaleString()}`;
        }
      };

      const activePanel = () => productPanels.find((panel) => !panel.hidden) || productPanels[0];

      const updateTransaction = () => {
        const price = Number(activePanel()?.dataset.price) || 0;
        if (quantityOutput) quantityOutput.textContent = String(quantity);
        if (priceOutput) priceOutput.textContent = formatPrice(price * quantity);
      };

      const setActiveProduct = (second) => {
        if (second === isSecondCard) return;
        isSecondCard = second;
        quantity = 1;
        productPanels.forEach((panel) => {
          panel.hidden = panel.dataset.panelProduct === 'second' ? !isSecondCard : isSecondCard;
        });
        updateTransaction();
      };

      const updateStagger = (progress) => {
        staggerItems.forEach(({ item, start, end }) => {
          const ratio = clamp((progress - start) / Math.max(.001, end - start));
          const opacity = 1 - ratio;
          item.style.opacity = opacity.toFixed(3);
          item.style.transform = `translate3d(0, ${(-64 * ratio).toFixed(2)}px, 0)`;
          item.style.filter = `blur(${(ratio * 10).toFixed(2)}px)`;
          item.style.pointerEvents = opacity < .15 ? 'none' : '';
        });
      };

      const scrubVideo = (video, targetRatio, currentTime, timestamp, index) => {
        if (!video || !Number.isFinite(video.duration) || video.duration <= 0) return currentTime;
        const nextTime = lerp(currentTime, targetRatio * video.duration, .16);
        const canSeek = timestamp - lastSeekTimes[index] >= 34;
        if (canSeek && !video.seeking && Math.abs(video.currentTime - nextTime) > .028) {
          video.currentTime = nextTime;
          lastSeekTimes[index] = timestamp;
        }
        return nextTime;
      };

      const setSheetOpen = (open) => {
        if (!sheet || open === isSheetOpen) return;
        isSheetOpen = open;
        sheet.classList.toggle('is-open', open);
        sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
        sheet.toggleAttribute('inert', !open);
      };

      const smoothUpdate = (timestamp) => {
        if (!section.isConnected) return;
        if (reducedMotion.matches) {
          videos.forEach((video) => video.pause());
          frameId = window.requestAnimationFrame(smoothUpdate);
          return;
        }

        if (!isVisible) {
          frameId = window.requestAnimationFrame(smoothUpdate);
          return;
        }

        currentScrollFraction = lerp(currentScrollFraction, targetScrollFraction, .09);
        if (Math.abs(currentScrollFraction - targetScrollFraction) < .0001) currentScrollFraction = targetScrollFraction;
        const progress = clamp(currentScrollFraction);

        if (progress <= .4) {
          const ratio = progress / .4;
          targetVideoRatio = ratio;
          targetVideoSecondRatio = 0;
        } else if (progress <= .5) {
          targetVideoRatio = 1;
          targetVideoSecondRatio = 0;
        } else if (progress <= .9) {
          const ratio = (progress - .5) / .4;
          targetVideoRatio = 1;
          targetVideoSecondRatio = ratio;
        } else {
          targetVideoRatio = 1;
          targetVideoSecondRatio = 1;
        }

        currentVideoTime = scrubVideo(videos[0], targetVideoRatio, currentVideoTime, timestamp, 0);
        currentVideoSecondTime = scrubVideo(videos[1], targetVideoSecondRatio, currentVideoSecondTime, timestamp, 1);

        if (Math.abs(progress - lastRenderedProgress) > .0002) {
          if (mediaLayers[0]) mediaLayers[0].style.opacity = progress < .48 ? '.88' : '0';
          if (mediaLayers[1]) mediaLayers[1].style.opacity = progress >= .48 ? '.88' : '0';
          if (progressBar) progressBar.style.width = `${progress * 100}%`;
          if (editorial) {
            editorial.style.pointerEvents = progress > .45 ? 'none' : '';
            editorial.style.visibility = progress >= .45 ? 'hidden' : 'visible';
          }
          updateStagger(progress);
          const second = progress >= .9;
          setActiveProduct(second);
          setSheetOpen((progress >= .39 && progress < .53) || second);
          lastRenderedProgress = progress;
        }

        frameId = window.requestAnimationFrame(smoothUpdate);
      };

      section.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.addEventListener('click', () => {
          quantity = clamp(quantity + Number(button.dataset.quantityStep), 1, 9);
          updateTransaction();
        });
      });

      backButton?.addEventListener('click', () => scrollToProgress(isSecondCard ? .82 : .35));
      finalButton?.addEventListener('click', () => scrollToProgress(.93));
      addButton?.addEventListener('click', () => {
        const originalLabel = addButton.textContent;
        addButton.textContent = 'ADDED TO ATELIER BAG';
        if (addStatus) addStatus.textContent = `${quantity} item${quantity === 1 ? '' : 's'} added to atelier bag`;
        window.setTimeout(() => { addButton.textContent = originalLabel; }, 1400);
      });

      scrollRoot.addEventListener('scroll', updateTarget, { passive: true });
      window.addEventListener('resize', updateLayout, { passive: true });
      reducedMotion.addEventListener('change', updateTarget);
      const readyHandlers = videos.map((video) => {
        const markReady = () => video.closest('[data-sculpted-layer]')?.classList.add('is-video-ready');
        video.pause();
        if (video.readyState >= 2) markReady();
        else video.addEventListener('loadeddata', markReady, { once: true });
        return markReady;
      });
      const visibilityObserver = new IntersectionObserver((entries) => {
        isVisible = entries[0]?.isIntersecting ?? true;
      }, { root: scrollRoot === window ? null : scrollRoot, rootMargin: '100% 0px' });
      visibilityObserver.observe(section);
      updateLayout();
      timeoutId = window.setTimeout(updateLayout, 500);
      updateTransaction();
      frameId = window.requestAnimationFrame(smoothUpdate);

      section._tdSculptedCleanup = () => {
        window.cancelAnimationFrame(frameId);
        window.clearTimeout(timeoutId);
        scrollRoot.removeEventListener('scroll', updateTarget);
        window.removeEventListener('resize', updateLayout);
        reducedMotion.removeEventListener('change', updateTarget);
        visibilityObserver.disconnect();
        videos.forEach((video, index) => video.removeEventListener('loadeddata', readyHandlers[index]));
      };
    }

    const initializeAll = (root = document) => {
      if (root.matches?.('[data-td-sculpted]')) initializeSculpted(root);
      root.querySelectorAll?.('[data-td-sculpted]').forEach(initializeSculpted);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches?.('[data-td-sculpted]') ? event.target : event.target.querySelector?.('[data-td-sculpted]');
      section?._tdSculptedCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
